// AI へ送信するビューモデル関連データを RTDB から取得する fetch 関数群。
import { RefBuilder } from '@framework/repository';
import { RTDBPath, type ModelId, type NodeId, type NodeReactionJSON, type ViewModelId } from 'balus-common';
import { ViewModelCascadeRepository } from '@view-model/infrastructure/view-model/cascade/ViewModelCascadeRepository';
import type { ViewModelContentJSON } from './types';

export async function fetchViewModelContentsJSON(viewModelId: string): Promise<ViewModelContentJSON> {
  const repository = new ViewModelCascadeRepository(viewModelId);
  const content = await repository.loadContent();
  if (!content) {
    throw new Error('ViewModelContent is not found.');
  }
  return content.dump();
}

type FetchNodeReactionsJSONResult = Record<ModelId, Record<NodeId, NodeReactionJSON>>;
export async function fetchNodeReactionsJSON(
  viewModelId: ViewModelId,
  modelIds: ModelId[]
): Promise<FetchNodeReactionsJSONResult> {
  const result: FetchNodeReactionsJSONResult = {};

  await Promise.all(
    modelIds.map(async (modelId) => {
      const ref = RefBuilder.ref(RTDBPath.App.ViewModel.Model.Node.reactionsPath(viewModelId, modelId));
      const snapshot = await ref.once('value');
      if (snapshot.exists()) {
        const val = snapshot.val() as Record<NodeId, NodeReactionJSON>;
        result[modelId] = val;
      }
    })
  );

  return result;
}
